//	Carousel for category landing pages

/** Single Element View swipe carousel **/
function Swipe(e,t){"use strict";function h(){o=s.children;f=o.length;if(o.length<2)t.continuous=false;if(i.transitions&&t.continuous&&o.length<3){s.appendChild(o[0].cloneNode(true));s.appendChild(s.children[1].cloneNode(true));o=s.children}u=new Array(o.length);a=e.getBoundingClientRect().width||e.offsetWidth;s.style.width=o.length*a+"px";var n=o.length;while(n--){var r=o[n];r.style.width=a+"px";r.setAttribute("data-index",n);if(i.transitions){r.style.left=n*-a+"px";g(n,l>n?-a:l<n?a:0,0)}}if(t.continuous&&i.transitions){g(v(l-1),-a,0);g(v(l+1),a,0)}if(!i.transitions)s.style.left=l*-a+"px";e.style.visibility="visible"}function p(){if(t.continuous)m(l-1);else if(l)m(l-1)}function d(){if(t.continuous)m(l+1);else if(l<o.length-1)m(l+1)}function v(e){return(o.length+e%o.length)%o.length}function m(e,n){if(l==e)return;if(i.transitions){var s=Math.abs(l-e)/(l-e);if(t.continuous){var f=s;s=-u[v(e)]/a;if(s!==f)e=-s*o.length+e}var h=Math.abs(l-e)-1;while(h--)g(v((e>l?e:l)-h-1),a*s,0);e=v(e);g(l,a*s,n||c);g(e,0,n||c);if(t.continuous)g(v(e-s),-(a*s),0)}else{e=v(e);b(l*-a,e*-a,n||c)}l=e;r(t.callback&&t.callback(l,o[l]))}function g(e,t,n){y(e,t,n);u[e]=t}function y(e,t,n){var r=o[e];var i=r&&r.style;if(!i)return;i.webkitTransitionDuration=i.MozTransitionDuration=i.msTransitionDuration=i.OTransitionDuration=i.transitionDuration=n+"ms";i.webkitTransform="translate("+t+"px,0)"+"translateZ(0)";i.msTransform=i.MozTransform=i.OTransform="translateX("+t+"px)"}function b(e,n,r){if(!r){s.style.left=n+"px";return}var i=+(new Date);var u=setInterval(function(){var a=+(new Date)-i;if(a>r){s.style.left=n+"px";if(w)S();t.transitionEnd&&t.transitionEnd.call(event,l,o[l]);clearInterval(u);return}s.style.left=(n-e)*(Math.floor(a/r*100)/100)+e+"px"},4)}function S(){E=setTimeout(d,w)}function x(){w=0;clearTimeout(E)}var n=function(){};var r=function(e){setTimeout(e||n,0)};var i={addEventListener:!!window.addEventListener,touch:"ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch,transitions:function(e){var t=["transitionProperty","WebkitTransition","MozTransition","OTransition","msTransition"];for(var n in t)if(e.style[t[n]]!==undefined)return true;return false}(document.createElement("swipe"))};if(!e)return;var s=e.children[0];var o,u,a,f;t=t||{};var l=parseInt(t.startSlide,10)||0;var c=t.speed||300;t.continuous=t.continuous!==undefined?t.continuous:true;var w=t.auto||0;var E;var T={};var N={};var C;var k={handleEvent:function(e){switch(e.type){case"touchstart":this.start(e);break;case"touchmove":this.move(e);break;case"touchend":r(this.end(e));break;case"webkitTransitionEnd":case"msTransitionEnd":case"oTransitionEnd":case"otransitionend":case"transitionend":r(this.transitionEnd(e));break;case"resize":r(h.call());break}if(t.stopPropagation)e.stopPropagation()},start:function(e){var t=e.touches[0];T={x:t.pageX,y:t.pageY,time:+(new Date)};C=undefined;N={};s.addEventListener("touchmove",this,false);s.addEventListener("touchend",this,false)},move:function(e){if(e.touches.length>1||e.scale&&e.scale!==1)return;if(t.disableScroll)e.preventDefault();var n=e.touches[0];N={x:n.pageX-T.x,y:n.pageY-T.y};if(typeof C=="undefined"){C=!!(C||Math.abs(N.x)<Math.abs(N.y))}if(!C){e.preventDefault();x();if(t.continuous){y(v(l-1),N.x+u[v(l-1)],0);y(l,N.x+u[l],0);y(v(l+1),N.x+u[v(l+1)],0)}else{N.x=N.x/(!l&&N.x>0||l==o.length-1&&N.x<0?Math.abs(N.x)/a+1:1);y(l-1,N.x+u[l-1],0);y(l,N.x+u[l],0);y(l+1,N.x+u[l+1],0)}}},end:function(e){var n=+(new Date)-T.time;var r=Number(n)<250&&Math.abs(N.x)>20||Math.abs(N.x)>a/2;var i=!l&&N.x>0||l==o.length-1&&N.x<0;if(t.continuous)i=false;var f=N.x<0;if(!C){if(r&&!i){if(f){if(t.continuous){g(v(l-1),-a,0);g(v(l+2),a,0)}else{g(l-1,-a,0)}g(l,u[l]-a,c);g(v(l+1),u[v(l+1)]-a,c);l=v(l+1)}else{if(t.continuous){g(v(l+1),a,0);g(v(l-2),-a,0)}else{g(l+1,a,0)}g(l,u[l]+a,c);g(v(l-1),u[v(l-1)]+a,c);l=v(l-1)}t.callback&&t.callback(l,o[l])}else{if(t.continuous){g(v(l-1),-a,c);g(l,0,c);g(v(l+1),a,c)}else{g(l-1,-a,c);g(l,0,c);g(l+1,a,c)}}}s.removeEventListener("touchmove",k,false);s.removeEventListener("touchend",k,false)},transitionEnd:function(e){if(parseInt(e.target.getAttribute("data-index"),10)==l){if(w)S();t.transitionEnd&&t.transitionEnd.call(e,l,o[l])}}};h();if(w)S();if(i.addEventListener){if(i.touch)s.addEventListener("touchstart",k,false);if(i.transitions){s.addEventListener("webkitTransitionEnd",k,false);s.addEventListener("msTransitionEnd",k,false);s.addEventListener("oTransitionEnd",k,false);s.addEventListener("otransitionend",k,false);s.addEventListener("transitionend",k,false)}window.addEventListener("resize",k,false)}else{window.onresize=function(){h()}}return{setup:function(){h()},slide:function(e,t){x();m(e,t)},prev:function(){x();p()},next:function(){x();d()},getPos:function(){return l},getNumSlides:function(){return f},kill:function(){x();s.style.width="auto";s.style.left=0;var e=o.length;while(e--){var t=o[e];t.style.width="100%";t.style.left=0;if(i.transitions)y(e,0,0)}if(i.addEventListener){s.removeEventListener("touchstart",k,false);s.removeEventListener("webkitTransitionEnd",k,false);s.removeEventListener("msTransitionEnd",k,false);s.removeEventListener("oTransitionEnd",k,false);s.removeEventListener("otransitionend",k,false);s.removeEventListener("transitionend",k,false);window.removeEventListener("resize",k,false)}else{window.onresize=null}}}}if(window.jQuery||window.Zepto){(function(e){e.fn.Swipe=function(t){return this.each(function(){e(this).data("Swipe",new Swipe(e(this)[0],t))})}})(window.jQuery||window.Zepto)}


/* Address book last issue fix */

function addressLast(){
	$('.address-book-list > li:nth-child(3n)').addClass('last');
};

// Main nav hover effect

(function(e){e.fn.hoverIntent=function(t,n,r){var i={interval:100,sensitivity:7,timeout:0};if(typeof t==="object"){i=e.extend(i,t)}else if(e.isFunction(n)){i=e.extend(i,{over:t,out:n,selector:r})}else{i=e.extend(i,{over:t,out:t,selector:n})}var s,o,u,a;var f=function(e){s=e.pageX;o=e.pageY};var l=function(t,n){n.hoverIntent_t=clearTimeout(n.hoverIntent_t);if(Math.abs(u-s)+Math.abs(a-o)<i.sensitivity){e(n).off("mousemove.hoverIntent",f);n.hoverIntent_s=1;return i.over.apply(n,[t])}else{u=s;a=o;n.hoverIntent_t=setTimeout(function(){l(t,n)},i.interval)}};var c=function(e,t){t.hoverIntent_t=clearTimeout(t.hoverIntent_t);t.hoverIntent_s=0;return i.out.apply(t,[e])};var h=function(t){var n=jQuery.extend({},t);var r=this;if(r.hoverIntent_t){r.hoverIntent_t=clearTimeout(r.hoverIntent_t)}if(t.type=="mouseenter"){u=n.pageX;a=n.pageY;e(r).on("mousemove.hoverIntent",f);if(r.hoverIntent_s!=1){r.hoverIntent_t=setTimeout(function(){l(n,r)},i.interval)}}else{e(r).off("mousemove.hoverIntent",f);if(r.hoverIntent_s==1){r.hoverIntent_t=setTimeout(function(){c(n,r)},i.timeout)}}};return this.on({"mouseenter.hoverIntent":h,"mouseleave.hoverIntent":h},i.selector)}})(jQuery);

function initNav() {
	
		/* Add's class to subnav for load purposes */		
		$('#main-nav-list > li > ul').addClass('sub-nav');
	
		var umbrella_container = document.getElementById("main-nav-list"),
		blackout = document.createElement("div");
		
		(function () {
			var url_path = location.pathname,
				url_ands = /\-and\-/g,
				hyphens = /\-/g,
				main_section = url_path.substr(1,(url_path.indexOf("/",1)-1)),
				site_nav = document.getElementById("main-nav-list");
			
			/*try {	
				if (url_ands.test(main_section)) {
					main_section = main_section.replace(url_ands, "-");
				}
				else { 
					if (hyphens.test(main_section)) {
						main_section = main_section.replace(hyphens, "");
					}
				}
				
				// now select the correct li
				
				if (!!main_section) {
					document.getElementById("nav-" + main_section).className = "selected";
				}
			}
			catch (err) {
				// do nothing
			}*/
		})();
			
		blackout.setAttribute("id", "div_screen");
		blackout.style.height = $(window).height() + "px";

		$(window).on("resize", function(){
			$(blackout).css("height", $(window).height());
		});

		document.body.appendChild(blackout);

		if ("ontouchstart" in window) {
			$("#div_screen").click(function () {
									$("#div_screen").fadeOut();
									$("#main-nav-list").removeClass("nav-active");	
								});
							}

		//$(umbrella_container).removeClass("no-js");
		
		$(umbrella_container).hover(
			function () {
				$(blackout).stop(true, true).fadeIn(250);
				// Windows UI override
				$("#variant:focus").css("display", "none");
				// End override
				//$(this).addClass("nav-active");
			},
			function () {
				$(blackout).stop(true, true).fadeOut();
				// Windows UI override
				$("#variant").css("display", "block");
				// End override 
				//$(this).removeClass("nav-active");
			}
		);
		
		$("#main-nav-list > li").mouseover(
			function (event) {
				if (this.getAttribute("id") === "nav-inspireme") {
					$(blackout).css({
						"opacity" : "0",
						"filter"  : "alpha(opacity=0)"
					});
				}
				else {
					$(blackout).css({
						"opacity" : "0.15",
						"filter"  : "alpha(opacity=15)"
					});
				}
			}
		);
	}
	
		
	/* Width of subnav */

	function subnav()
	{	
		$('.sub-nav').each(function(i){
			var numberLi = $(this).children().length;
			$(this).css('width',numberLi * 200 - 20);
		});
	}
	
	/* Detect cookies */

 	function are_cookies_enabled()
	{
		var cookieEnabled = (navigator.cookieEnabled) ? true : false;
	
		if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled)
		{ 
			document.cookie="testcookie";
			cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
		}
		return (cookieEnabled);
	}

	/* Cross selling */

	function crossSell(){
		var crossSellItems = $('.cross-sell-list > li').length;
		if (crossSellItems >= 4)
		{
			$('.cross-sell-list').addClass('jcarousel-skin');

		}

	}

	/* Accessible Dropdowns 

	function accMenus(){
		$('.customer-service > h3').focus(function(){
			$('.customer-service').addClass('customer-service-acc');
		});

		$('.nav a').focus(function(){
			$('.customer-service').removeClass('customer-service-acc');
		});

		$('.us-flag').focus(function(){
			$('.flags-container').addClass('flags-container-acc');
		});

		$('.uk-flag').focusout(function(){
			$('.flags-container').removeClass('flags-container-acc');
		});

		$('body').click(function(){
			$('.customer-service').removeClass('customer-service-acc');
			$('.flags-container').removeClass('flags-container-acc');
		});

	}

	/* Flag message */

	function flags(event){
		event.preventDefault();
		$('#flags-message').show();
		/* $('.customer-service > h3').attr('tabindex','-1');
		$('a').attr('tabindex','-1');
		$('input, button').attr('disabled','disabled');
		$('.global-popup-message-text > .negative').attr('tabindex', '1');
		$('#flag-cancel').attr('tabindex', '2'); */
	}
		
	function hideFlags(){
		/* $('.customer-service > h3').attr('tabindex','0');
		$('a').attr('tabindex','0');
		$('.skiptocontent').attr('tabindex','1');
		$('.skiptonavigation').attr('tabindex','2');
		$('input, button').removeAttr('disabled');*/	
		$('#flags-message').hide(); 
	}; 

	

/**
*
* Usage
*
* $('.info').axHandler({
*    'requestType'    : 'get',
*     'responseDataType' : 'html'
* });
*
*/

(function($) {
 
  var methods = {
   
   init : function(options) {
    
    // context of 'this' here is the jQuery object of the element itself 
    //not the methods object literal
    
    // Default settings if none supplied
    var settings = $.extend( {
     'requestType'   : 'get',
     'responseDataType' : 'html'
       }, options); 
    
    
    methods.createDisplayDiv();
    
    var $requestContent = $('#div_ax_content');
    var $contentDiv = $('#div_popup');
    
    return this.each(function(){
     
     //maintain chainability
     //context of this is the element the plugin is being called on
     var $this = $(this);
     
     $this.click(function(event){
     
         var clickedLink = $(this);
      
      //Check if data popup contains uri to file
      //or actual html
      
     // var hasPath = clickedLink.attr("data-popup").indexOf('.html');
      
      
      // send ajax request 
       $.ajax({
       // Content to retrieve
       url: clickedLink.attr("data-popup"),
       
       // Request type
       type: settings.reqestType,
       
       // Data return type of response
       dataType: settings.responseDataType,
       
       error: function(){
        // Load the content in to the page.
        $requestContent.html("<p>Content Not Found!</p>");
 
       },
       
       complete: function(){
        $contentDiv.fadeIn('fast');
       },
       
       success: function(strData){



        // Load the content in to the page.
        $requestContent.html(strData);

         if ($(".error-404-page").length > 0) {

         	$("#div_ax_content").html("<p>Content Not Found!</p>");

         }

         if ($("#div_ax_content").text().trim() === "") {

          $("#div_ax_content").html("<p>Content Not Found!</p>");
          $("#div_ax_content").addClass("errored");

         }
		
       }

       });
  
      // Prevent default click.
      return(false);     
     });   
          });
     },
  
  createDisplayDiv : function(){
 
  // Check if popup container exists
  
  var axContentDiv = document.getElementById('div_popup');
  
  
  if (axContentDiv == undefined) {
   //using == typecasting as not sure if null is returned by all browsers
   //so don't want to explicity check for === null
  
   //create popuup 
    
   var new_div = document.createElement('div');
   new_div.setAttribute('id', 'div_popup');
 
   //add close button and to popup div
 
   var close = "<a id='a-close-popup'></a><div id='div_ax_content'></div>"
   new_div.innerHTML = close;
 
   // add the new div to the DOM
 
   document.getElementById('page').appendChild(new_div);
 	
   //create close div function
 
   var closeButton = document.getElementById('a-close-popup');
   var $popup_div = $('#div_popup');
 
   closeButton.onclick = function () {
    $popup_div.fadeOut('fast');
    //possibly change the text of the size guide
	

	
   }  
   
  }
  
  }
  
  } 
  
  $.fn.axHandler = function(method) {
    
   if (methods[method]) {
          return methods[method].apply( this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
       return methods.init.apply(this, arguments);
      } else {
          $.error('Method ' +  method + ' does not exist');
      } 
  };
  
 
  
})(jQuery);

/* Second carousel */


var Carousel = function (config /*carouselElement, transition, loop, mobile*/) {
 
    //Get user defined options
 
    this.carouselContainer = config.carouselElement;
    this.transition = config.transition; //choose transition slide or crossfade
    this.loop = config.loop; // auto rotate the carousel?
    this.slides = config.slides; // number of slides to show in view
    this.leftArrowSrc = config.leftArrow;
    this.rightArrowSrc = config.rightArrow;
    this.topArrowPos = config.topArrowPos;
    this.showArrows = config.showArrows;
    this.loopInterval = config.loopInterval;
			  
    var _self = this;
               
    this.startSlide = (function(){
                   
	   var url = window.location.href;
	   var questionMark = url.indexOf('?');                      
	   var geSlideNum;
   
	   if (questionMark === -1) {
	                   // Start with first slide if no slide number in url
	       getSlideNum = 0;
                   
	   } else {
	       var parameter = url.substring(questionMark);
	       var numPattern = /\d\d?/;
	       //pattern returns an array of strings
	       //Get the first match and return the as integer 
	       getSlideNum = numPattern.exec(parameter);
       
	       if (getSlideNum === null) {
	                       return getSlideNum = 0;
	       } else {
	                       getSlideNum = parseInt(getSlideNum[0], 10);
	       }
                   
	   }
	   return getSlideNum;
                   
    })();
 

	this.showArrows   = config.showArrows   || true;
	this.loopInterval = config.loopInterval || 6000; 
 	this.innerArrows  = config.innerArrows	|| true;
               
    this.carouselItems = this.carouselContainer.children[0];
 
    this.numCarouselSlides = this.carouselItems.children.length;
 
    this.slideIndicators = null;
    this.clickX = 0;
    this.clickY = 0;
 
    this.startX = 0;
    this.endX = 0;
    this.fadeDiv = null;
    this.fadeImg = null;
 
    //the width and height of one carousel item
    this.aElement = $(this.carouselItems).children().first();
    this.item_width = this.aElement.outerWidth();
 
    this.liSpacing = Math.abs(this.item_width - this.aElement.width());
    //get the length of the carousel
    this.carouselLength = this.item_width * this.numCarouselSlides;
 
    this.viewLength = this.item_width * this.slides;
    this.carouselContainer.style.width = this.viewLength + this.liSpacing + "px";
 
    // maximum available scroll right
    this.maxRight = -1 * (this.carouselLength - this.viewLength);
 
    // set the carousel length for the UL
    this.carouselItems.style.width = this.carouselLength + "px";
    //this.carouselItems.style.left = "0px";
    var containerOffset = this.findPosition(this.carouselContainer);
    this.carouselContainerOffset = parseInt(containerOffset[0], 10);
    this.nextSlideX = this.viewLength;
    this.prevSlideX = this.viewLength * -1;
 
    this.swipeSlowDown = 2;
    this.animating = false;
    //timer to handle crossfade transition loops
    this.rotateTimer = null;
    this.carouselItems.style.left = "0px";
 
 
 
    //Give all slides a slideIndex data attribute
    var slides = function () {
        var liElements = _self.carouselItems.children;
        for (var i = 0, length = liElements.length; i < length; i++) {
            liElements[i].setAttribute("data-slideindex", i);
        }
    }();
 
 
    if (this.transition === "slide"/* && !this.mobile*/) {
        //grab the width and calculate left value
        this.left_value = this.item_width * (-1);
        //move the last item before first item, just in case user click prev button
        //$(this.carouselItems.children).first().before($(this.carouselItems.children).last());
 
        //if there are more than one element in the view the carousel will reach the end and then stop
        this.finite = function () {
            var elementsInView = _self.viewLength / _self.item_width;
 
            if (elementsInView > 1) {
                return true;
            } else {
                return false;
            }
 
        }();
 
        if (!this.finite) {
            //clone the last item before first item, just in case user click prev button
                                               
            $(this.carouselItems.children).first().before($(this.carouselItems.children).last().clone());
           
            for(var i=0; i<this.startSlide; i++) {
                           
				//remove the cloned first item
                $(this.carouselItems).children().first().remove();

                //clone the new first item and put it as last item                
                $(this.carouselItems).children().last().after($(this.carouselItems).children().first().clone());

            }
                                               
            //readjust the width of the carousel
            this.carouselItems.style.width = ($(this.carouselItems).children().length * this.item_width) + "px";
 
            //set the default item to the correct position
            $(this.carouselItems).css({ 'left': this.left_value });
        }
    }
 
    if (this.loop) {
  
        this.autoRotate();
                               
        $(this.carouselContainer).on('mouseout', function(){
        	_self.autoRotate();
        });
        $(this.carouselContainer).on('mouseover', function(){
                        clearInterval(_self.rotateTimer);
        });

    }
 
    //loop through li's and set width needed for mobile
  
        // get image width attribute
        this.imgWidth = parseInt($(this.carouselItems).find('img')[0].getAttribute('width'), 10);
        var carouselElements = this.carouselItems.children;
        for (var i = 0, length = carouselElements.length; i < length; i++) {
            carouselElements[i].style.width = this.imgWidth + "px";
 
        }
                
 
        this.item_height = this.aElement.outerHeight();
        this.carouselContainer.style.height = this.item_height + "px";
 
        this.viewLength = (this.imgWidth + this.liSpacing) * this.slides;
 
        //get the length of the carousel
        this.carouselLength = (this.imgWidth + this.liSpacing) * this.numCarouselSlides;
 
        // maximum available scroll right
        this.maxRight = -1 * (this.carouselLength - this.viewLength);
 
        this.nextSlideX = this.viewLength;
        this.prevSlideX = this.viewLength * -1;
 
        this.carouselContainer.style.width = this.viewLength + this.liSpacing + "px";
                               
        this.carouselItems.style.width = this.carouselLength + "px";
 

    //add the arrows, slide indicators and fade div depending user defined carousel options
    this.addControls();
    if (this.transition === "crossfade") {
        this.setInitialSlide();
    }
}
 
 
 
Carousel.prototype.getCurrentSlide = function () {
 
    //caculate current slide to update indicators
    var currLeft = this.carouselItems.offsetLeft;
    var currSlide = Math.abs(Math.round(currLeft / this.viewLength));
    return currSlide;
 
}
 
Carousel.prototype.addControls = function () {
 
    //Adds arrow and dot indicators if necessary.
    //binds click events to arrows and dots.
	
	var _self = this;
 
    if (this.numCarouselSlides > 0) {
        //build dot slide indicators and arrow buttons if more than one slide
        var ol, li, rightArrow, leftArrow, leftImg, rightImg, fadeDiv, fadeImg;
 
 
        //create the dot indicators
        ol = document.createElement('ol');
        ol.className = "slide_indicators";
        for (var i = 0; i < this.numCarouselSlides; i++) {
            li = document.createElement('li');
            li.className = 'not-active';
            li.setAttribute('data-slideindex', i);
            ol.appendChild(li);
        }
        //set the indicator of the slides to the first one
        ol.firstChild.className = "active";
        //add indicators to the dom
        this.carouselContainer.appendChild(ol);
 
        // hide slide indicators if the carousel has more than one slide in the view
        if (this.slides > 1 || this.iPhone) {
           ol.style.visibility = "hidden"
        }
 
        //Get a list of all the dot indicators
        this.slideIndicators = ol.children;
 
 
        // create the arrows for previous and next slide
        this.rightArrow = document.createElement('div');
        this.leftArrow = document.createElement('div');
        leftImg = document.createElement('img');
        rightImg = document.createElement('img');
 
        leftImg.setAttribute('src', this.leftArrowSrc);
        rightImg.setAttribute('src', this.rightArrowSrc);
 
        this.rightArrow.style.top = this.leftArrow.style.top = this.topArrowPos + "px";
 
        this.rightArrow.className = "c-arrow c-rightArrow active-arrow";
        this.leftArrow.className = "c-arrow c-leftArrow inactive-arrow";
 
        this.rightArrow.appendChild(rightImg);
        this.leftArrow.appendChild(leftImg);
 
        if (this.showArrows && this.innerArrows) {
 
            //add arrows to the dom
 
            this.carouselContainer.appendChild(this.leftArrow);
            this.carouselContainer.appendChild(this.rightArrow);
                                               
        } else if(this.showArrows && !this.innerArrows){
            $(this.carouselContainer).wrap("<div class='column pos-rel width-fit' style='margin-left:0'></div>")
            $(this.leftArrow).insertBefore(this.carouselContainer);
            $(this.rightArrow).insertAfter(this.carouselContainer);
                                                                                  
        }
                   
 
        //bind click events to left and right arrow buttons
 
        if (this.transition === "crossfade") {
 
            //create a div to hold the fadeimage
            fadeDiv = document.createElement('div');
            fadeImg = document.createElement('img');
            fadeDiv.className = "pos-abs";
 
            //add image to div
            fadeDiv.appendChild(fadeImg);
            this.carouselContainer.appendChild(fadeDiv);
 
            //set fadeDiv and fadeImg so can be used in functions
            this.fadeDiv = fadeDiv;
            this.fadeImg = fadeImg;
 
            //bind crossfade functions                                                
                                                               
            $(this.rightArrow).on("click", function(){
                            _self.changeSlideCrossFade("next");
            });
           
            $(this.leftArrow).on("click", function(){
                            _self.changeSlideCrossFade("prev");
            });
                                                
 
       } else if (this.transition === "slide") {
            //bind slide function
                                                             
            $(this.rightArrow).on("click", function(){
                            _self.changeSlideScroll("next");
            });
           
            $(this.leftArrow).on("click", function(){
                            _self.changeSlideScroll("prev");
            });
                                                
 
            var currentLeft = parseInt(this.carouselItems.style.left, 10);
            
			if (currentLeft === 0) {
                $(this.leftArrow).removeClass('active-arrow').addClass('inactive-arrow');
            } else {
                $(this.leftArrow).removeClass('inactive-arrow').addClass('active-arrow');
            }
 
        }
 
        //bind click event to dot slide indicators
        if (this.transition === "crossfade") {
                                                       
            $(ol).on("click", function(){
                            _self.directToSlide();
            });
        }
    }
 
}
 
Carousel.prototype.setSlideIndicator = function (slideIndex) {
 
    var slidesLength = this.slideIndicators.length;
    for (var i = 0; i < slidesLength; i++) {
        this.slideIndicators[i].className = "not-active";
    }
    this.slideIndicators[slideIndex].className = "active";
}
 
Carousel.prototype.changeSlideCrossFade = function (direction) {
    //direction is left or right
 
        if (this.loop) { clearInterval(this.rotateTimer); }
        // set animation flag as animation started
        this.animating = true;
        //get the current slide
        var currSlideIndex = this.getCurrentSlide();
        var lastAvailableSlide = this.numCarouselSlides - 1;
 
 
        if (direction === "next") {
 
            if (currSlideIndex === lastAvailableSlide) {
                //have reached the end start again from the beginning
                this.findSlideToFade.call(this, lastAvailableSlide);
                var move = 0;
            } else if (currSlideIndex < (this.numCarouselSlides - 1)) {
                this.findSlideToFade(currSlideIndex);
                //move the carousel to the next location
                var move = (currSlideIndex + 1) * this.viewLength * -1;
            }
 
        } else if (direction === "prev") {
 
            if (currSlideIndex === 0) {
                //have reached the end start again from the beginning
                this.findSlideToFade(0);
                var move = lastAvailableSlide * this.viewLength * -1;
            } else if (currSlideIndex > 0) {
                this.findSlideToFade(currSlideIndex);
                //move the carousel to the next location
                var move = (currSlideIndex - 1) * this.viewLength * -1;
            }
 
        }
        //move the carousel to the relevant position
        this.carouselItems.style.left = move + "px";
 
        //fade the overlay div out once the carousel has moved to the correct place
  
                                $(this.fadeDiv).fadeOut(300);
 
        // Get and update the curren slide index
        currSlideIndex = this.getCurrentSlide();
        this.setSlideIndicator(currSlideIndex);
}
 
Carousel.prototype.changeSlideScroll = function (direction) {
	
	var _self = this;
 
    if (!this.animating) {
 
        if (this.loop) { clearInterval(this.rotateTimer); }
 
        this.animating = true;
 
        if (direction === "next") {
 
            if (!this.finite) {
                //this carousel will be infinate
 
                //get the right position
                var left_indent = parseInt($(this.carouselItems).css('left')) - this.item_width;
 
                //slide the item
                $(this.carouselItems).animate({ 'left': left_indent }, 500, function () {
 
                    //move the first item and put it as last item                
                    //$(this.carouselItems).children().last().after($(this.carouselItems).children().first());
 
                    //remove the cloned first item
                    $(_self.carouselItems).children().first().remove();
 
                    //clone the new first item and put it as last item                
                    $(_self.carouselItems).children().last().after($(_self.carouselItems).children().first().clone());
 
                    //set the default item to correct position
                    $(_self.carouselItems).css({ 'left': _self.left_value });
 
                    //animation has finished
                    _self.animating = false;
 
                    //Update the slide indicator
                    var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                    _self.setSlideIndicator(currentSlideIndex);
 
                });
							
            } else {
                //this carousel will stop when it reaches the end
 
                //get the current left position of the carousel
                var currentLeft = parseInt(this.carouselItems.style.left, 10);
 
                //how much of the carousel is left to scroll
                var leftToScroll = this.carouselLength - (Math.abs(currentLeft) + this.viewLength);
 
                if (leftToScroll < this.viewLength) {
                    //scroll to the end of the remainder of the carousel
                    if (leftToScroll === 0) { this.animating = false; return; }
                    $(this.carouselItems).animate({ 'left': "-=" + leftToScroll }, 500, function () {
 
                        //animation has finished
                        _self.animating = false;
 
                        //Update the slide indicator
                        var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                        _self.setSlideIndicator(currentSlideIndex);
 
                        currentLeft = parseInt(_self.carouselItems.style.left, 10);
 
                        leftToScroll = _self.carouselLength - (Math.abs(currentLeft) + _self.viewLength);
 
                        if (leftToScroll === 0) {
                            $(_self.rightArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        }
 
                        if (currentLeft === 0) {
                            $(_self.leftArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        } else {
                            $(_self.leftArrow).removeClass('inactive-arrow').addClass('active-arrow');
                        }
 
                    });
 
                } else {
                    //scroll full amount of view
                    $(this.carouselItems).animate({ 'left': "-=" + _self.viewLength }, 500, function () {
 
                        //animation has finished
                        _self.animating = false;
 
                        //Update the slide indicator
                        var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                        _self.setSlideIndicator(currentSlideIndex);
 
                        currentLeft = parseInt(_self.carouselItems.style.left, 10);
 
                        leftToScroll = _self.carouselLength - (Math.abs(currentLeft) + _self.viewLength);
 
                        if (leftToScroll === 0) {
                            $(_self.rightArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        }
 
                        if (currentLeft === 0) {
                            $(_self.leftArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        } else {
                            $(_self.leftArrow).removeClass('inactive-arrow').addClass('active-arrow');
                        }
 
                    });
                }
			}
        } else if (direction === "prev") {
 
            if (!this.finite) {
                //this carousel will be infinate
 
                //get the right position           
                var left_indent = parseInt($(_self.carouselItems).css('left')) + _self.item_width;
 
                //slide the item           
                $(this.carouselItems).animate({ 'left': left_indent }, 500, function () {
 
                    //move the last item and put it as first item              
                    //$(this.carouselItems).children().first().before($(this.carouselItems).children().last());     
 
                    //remove the cloned last item
                    $(_self.carouselItems).children().last().remove();
 
                    //move the last item and put it as first item              
                    $(_self.carouselItems).children().first().before($(_self.carouselItems).children().last().clone());
 
                    //set the default item to correct position
                    $(_self.carouselItems).css({ 'left': _self.left_value });
 
                    //animation has finished
                    _self.animating = false;
 
                    //Update the slide indicator
                    var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                    _self.setSlideIndicator(currentSlideIndex);
 
                });
            } else {
 
                //this carousel will stop when it reaches the end
 
                //get the current left position of the carousel
                var currentLeft = parseInt(this.carouselItems.style.left, 10);
 
                if (currentLeft === 0) { this.animating = false; return; }
 
                //how much of the carousel is left to scroll
                var leftToScroll = Math.abs(currentLeft);
 
                if (leftToScroll < this.viewLength) {
                    //scroll to the end of the remainder of the carousel
 
                    $(this.carouselItems).animate({ 'left': "+=" + leftToScroll }, 500, function () {
 
                        //animation has finished
                        _self.animating = false;
 
                        //Update the slide indicator
                        var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                        _self.setSlideIndicator(currentSlideIndex);
 
                        currentLeft = parseInt(_self.carouselItems.style.left, 10);
                        if (currentLeft === 0) {
                            $(_self.leftArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        } else {
                            leftToScroll = _self.carouselLength - (Math.abs(currentLeft) + _self.viewLength);
                        }
 
                        if (leftToScroll !== 0) {
                            $(_self.rightArrow).removeClass('inactive-arrow').addClass('active-arrow');
                        } else {
                            $(_self.rightArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        }
 
                    });
 
                } else {
 
                    //scroll full amount of view
                    $(this.carouselItems).animate({ 'left': "+=" + _self.viewLength }, 500, function () {
 
                        //animation has finished
                        _self.animating = false;
 
                        //Update the slide indicator
                        var currentSlideIndex = parseInt(_self.carouselItems.children[1].getAttribute("data-slideindex"));
 
                        _self.setSlideIndicator(currentSlideIndex);
 
                        currentLeft = parseInt(_self.carouselItems.style.left, 10);
                        if (currentLeft === 0) {
                            $(_self.leftArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        }
 
                        leftToScroll = _self.carouselLength - (Math.abs(currentLeft) + _self.viewLength);
 
                        if (leftToScroll !== 0) {
                            $(_self.rightArrow).removeClass('inactive-arrow').addClass('active-arrow');
                        } else {
                            $(_self.rightArrow).removeClass('active-arrow').addClass('inactive-arrow');
                        }
 
                    });
                }
            }
        }
    }
}
 
Carousel.prototype.findSlideToFade = function (slideIndex) {
    if (this.transition === "crossfade") {
        //get image of current slide
        var currSlideImg = this.carouselItems.children[slideIndex].getElementsByTagName('img')[0].src;
        //set the fade image src to the image src of the current slide
        this.fadeImg.src = currSlideImg;
        //display the fadeDiv with the current slide image so that the carousel can move to the next location
        this.fadeDiv.style.opacity = 1;
        this.fadeDiv.style.display = "block";
    }
 
}
 
Carousel.prototype.directToSlide = function (e) {
    // only used for crossfade transition
    if (this.loop) { clearInterval(this.rotateTimer); }
               
               
    var e = e || window.event;
    var target = getEvent(e, "target");
    var currSlideIndex = this.getCurrentSlide();
   
    if (target.nodeName.toLowerCase() === 'li') {
   
        var slideIndex = parseInt(target.getAttribute('data-slideIndex'));
        if (currSlideIndex === slideIndex) { return; }
        this.findSlideToFade.call(this, currSlideIndex);
        var move = (slideIndex * this.viewLength) * -1;
        this.carouselItems.style.left = move + "px";
        $(this.fadeDiv).fadeOut(300);

        currSlideIndex = this.getCurrentSlide();
        this.setSlideIndicator(currSlideIndex);
    }
               
}
 
Carousel.prototype.setInitialSlide = function() {
               
        var currSlideIndex = this.getCurrentSlide();
 
        if (currSlideIndex === this.startSlide || this.startSlide > (this.numCarouselSlides-1)) { return; }
   
        this.findSlideToFade.call(this, currSlideIndex);
        var move = (this.startSlide * this.viewLength) * -1;
        this.carouselItems.style.left = move + "px";               
        $(this.fadeDiv).fadeOut(300);
 
        currSlideIndex = this.getCurrentSlide();
        this.setSlideIndicator(currSlideIndex);
                               
        var slideLeftPos = this.viewLength * currSlideIndex;
       
        this.nextSlideX = Math.abs(slideLeftPos + this.viewLength);
        this.prevSlideX = Math.abs(slideLeftPos - this.viewLength);
 
}
 
Carousel.prototype.autoRotate = function () {
 
    //this function is only used for the crossfade transition
	var _self = this;
	
    this.rotateTimer = setInterval(function () {
				
        if (_self.transition === "crossfade") {
            _self.changeSlideCrossFade("next");
        } else if (_self.transition === "slide") {
            _self.changeSlideScroll("next");
        }
        _self.autoRotate();
    }, _self.loopInterval);
}
 
Carousel.prototype.findPosition = function (element) {
 
    var curleft = curtop = 0;
 
    if (element.offsetParent) {
        do {
            curleft += element.offsetLeft;
            curtop += element.offsetTop;
        } while (element = element.offsetParent);	
    }
 
    return [curleft, curtop];
 
}

mapAccordian = function(){
	$(".interactive-map g").children().click(function(){
		var countryId = $(this).parent().attr("id");

		if($(this).parent().attr("id") == "london")
		{
			$("#uk-map").fadeOut(400);
			$("#london-map").fadeIn(400);
			if($("#" + countryId + "-list > ol").is(':hidden')){
				$(".current-country").attr("class","country");
				$(".current-list > ol").slideUp(400);
				$(".current-list").removeClass("current-list");
				$("#" + countryId + "-list").addClass("current-list");
				$("#" + countryId + "-list > ol").slideDown(800);
				$(this).parent().attr("class","country current-country");
			}
		}
		else {
			if($("#" + countryId + "-list > ol").is(':hidden')){
				$(".current-country").attr("class","country");
				$(".current-list > ol").slideUp(400);
				$(".current-list").removeClass("current-list");
				$("#" + countryId + "-list").addClass("current-list");
				$("#" + countryId + "-list > ol").slideDown(800);
				$(this).parent().attr("class","country current-country");
			}
		}

	});
};

/* DOCUMENT READY */
$(document).ready(function(){

/* Flags ipad fall back */
		if ("ontouchstart" in window){
			$('.us-flag').click(function(){
				$('.sub-flags').toggle();
			});
		}
		
		/* Flag message */
//		TWCM-499
//		Line below needs to be uncommented for production
		 $('.uk-flag > a').click(flags);
		
		$('#flag-cancel').click(hideFlags);
		$('#flag-cancel').keypress(hideFlags); //for accessability

		/* Main nav */
		initNav();
		
		/* Address box fix */
		addressLast();
		
		/* Subnav */		
		subnav();

		/* Cookies */
		if(!are_cookies_enabled())
		{
			$('.cookie-message').css('display', 'block');			
		}
		
		/* Cross selling */
		crossSell();

		/* Accessible dropdown
		accMenus();
		 */

		/* Empty Cross Selling */
		if($('.pdp-bottom > div').children('div').length < 1){
			$('.pdp-bottom').hide();
		};

		// USA popup

		if(window.location.search.indexOf("uk=1") > -1) {
		    $('.popup-usa-container').show();
		}
	
		$('.popup-usa-link').click(function(event){
			event.preventDefault();
			$('.popup-usa-container').hide();
		});
	
		$('.popup-usa-close').click(function(event){
			$('.popup-usa-container').hide();
		});
		
		// Map Accordian
		mapAccordian();

	}); 

